import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let ShareModel = class ShareModel extends Vue {
    get mpurl() {
        return this.tipConfig.appurl || require('@/assets/share-code.jpg');
    }
};
tslib_1.__decorate([
    Prop()
], ShareModel.prototype, "close", void 0);
tslib_1.__decorate([
    Prop({ default: {} })
], ShareModel.prototype, "tipConfig", void 0);
ShareModel = tslib_1.__decorate([
    Component
], ShareModel);
export default ShareModel;
